type FetchTagListResponseItem = {
  alias: string;
  name: string;
  color: number;
  parent?: string;
};

const addTagsOnLevel = (
  childTags: FetchTagListResponseItem[],
  level: number,
  rootAlias: string,
  map: TagMapT,
  origin: FetchTagListResponseItem[],
): TagMapT => {
  let newMap = { ...map };
  childTags.map((item) => {
    const children = origin.filter((i) => i.parent === item.alias);
    const tag = {
      alias: item.alias,
      name: item.name,
      color: item.color,
      level: level,
      parent: item.parent !== undefined ? item.parent : rootAlias,
      children: children.map((child) => child.alias),
    };

    newMap[tag.alias] = tag;

    if (children.length > 0)
      newMap = addTagsOnLevel(children, level + 1, rootAlias, newMap, origin);
  });
  return newMap;
};

const ROOT_TAG_ALIAS = '0'.repeat(24);

const convertFetchTagListResponse = (
  data: FetchTagListResponseItem[],
): TagMapT => {
  // Create a root node for convenience
  const root: TagT = {
    alias: ROOT_TAG_ALIAS,
    name: 'root',
    color: 0,
    level: 0,
    parent: null,
    children: data.map((item) => item.alias),
  };
  let tagMap: TagMapT = {
    [root.alias]: root,
  };
  tagMap = addTagsOnLevel(
    data.filter((item) => !item.parent),
    1,
    root.alias,
    tagMap,
    data,
  );

  return tagMap;
};

export type { FetchTagListResponseItem };

export { convertFetchTagListResponse,ROOT_TAG_ALIAS };
